<!-- 
Expander panel showing the net profit ratio calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelNetProfitRatioScore)"
    >
      <v-icon class="financial-strength-breakdown">subdirectory_arrow_right</v-icon>
      Financial strength: Net profit ratio score
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.NetProfitRatioScore"/>
        <v-card-text class="pt-2 px-0 pb-0">
          <v-layout row wrap mx-4>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field label="Net profit ratio formula" label-width="11">
                Net profit before tax / Total revenue
              </our-data-field>
              <our-data-field label="Net profit ratio" label-width="11">
                {{ levyParameters.netProfitBeforeTax | currency }} / {{ levyParameters.totalRevenue | currency }}
                =
                <precise-risk-factor-number 
                  :value="levyCalculation.netProfitRatio"
                  :decimal-places="2"
                  :levy-collection-id="levyCollection.id" 
                  :estimator-key="estimatorKey" 
                  type="NetProfitRatio"
                />
              </our-data-field>
            </v-flex>
            <v-flex xs12 sm4 pb-4>
              <risk-factor-table
                :estimator-key="estimatorKey" 
                :levy-collection-id="levyCollection.id" 
                :selected-score="levyCalculation.netProfitRatioScore" 
                is-percentage 
                type="NetProfitRatio" 
                title="Net profit ratio"
                terminology="Score"
              />
            </v-flex>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field label="Net profit ratio score" typography="title" label-width="11">
                {{ levyCalculation.netProfitRatioScore | numericInput2 }}
                <template v-slot:footer>
                  <playground-up-down v-if="isLevyEstimator" field="netProfitRatioScore" show-original small/>
                </template>
              </our-data-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";
import RiskFactorTable from "@/components/levy-collection-providers/calculation/RiskFactorTable.vue";
import PreciseRiskFactorNumber from "@/components/levy-collection-providers/calculation/PreciseRiskFactorNumber.vue";

export default {
  components: {
    PlaygroundUpDown,
    RiskFactorTable,
    PreciseRiskFactorNumber
  },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  }
};
</script>
